
class Unit {

  constructor(model) {

    if (model.id) {
      this.id = model.id
    }

    this.type = model.get('type')

    this.color = function (color) {
      model.color(color)
      return this
    }

    this.data = function () {
      return model.data()
    }
  }
}

export default Unit
